<!-- 会员记录页 -->
<template>
  <div class='vipRecord'>
    <publicHeader :pageTitle="pageTitle" isWhite='true'></publicHeader>
    <div class="zhanwei">
    </div>
    <div class="recordList">
      <div class="recordItem" v-for="(item,index) in recordList" :key="index">
        <div class="line1">
          <div class="itemName">
            {{item.name}}
          </div>
          <div class="itemTime">
            {{item.long}}
          </div>
        </div>
        <div class="line">
          有效期至：{{item.endTime}}
        </div>
        <!-- 手动购买 -->
        <div class="line" v-if="item.type==1">

          <div class="time" v-if="item.renewTime">
            续费时间：{{item.renewTime}}
          </div>
          <div class="time" v-else>
            开通时间：{{item.buyTime}}
          </div>
        </div>
        <!-- 赠送 -->
        <div class="line" v-if="item.type==2">
          <div class="time">
            赠送时间：{{item.buyTime}}
          </div>
          <div class="origin">
            中国体育平台赠送
          </div>
        </div>
        <!-- 兑换 -->
        <div class="line" v-if="item.type==3">
          <div class="time">
            兑换时间：{{item.buyTime}}
          </div>
          <div class="origin">
            兑换会员
          </div>
        </div>
      </div>
    </div>
    <div class="nolog" v-if="!recordList.length">
      <div class="nodataImg">
        <img src="https://images.zhibo.tv/2021/0306/icon_nolog.png" alt="">
      </div>
      <div class="nodata">
        暂无记录
      </div>
    </div>
  </div>
</template>

<script>
import publicHeader from '../components/PublicHeader'
export default {
  components: { publicHeader },
  data () {
    return {
      page: 1,
      pagesize: 15,
      recordList: [],
      // 用于滚动加载
      isLoading: false,
      pageTitle: '',
      token: ''
    }
  },
  created () {
    this.getToken()
    document.title = '会员记录'
    this.pageTitle = '会员记录'
    this.getVipRecord()
    this.scroll()
    this.changeAppTitle('会员记录')
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题', newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题", newtitle)
      }
    },
    // 获取会员记录
    getVipRecord () {
      let params = {
        token: this.token,
        page: this.page,
        pagesize: this.pagesize,
        statistics: this.$CONFIG.statistics
      }
      this.$vipapi.getVipRecord(params).then(res => {
        // console.log(res);
        this.isLoading = false
        this.recordList.push(...res.data.data)
      })
    },
    // 滚动加载
    scroll () {
      window.onscroll = () => {
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight // document的滚动高度
        const nowScotop = document.documentElement.clientHeight || document.body.clientHeight // 可视区高度
        const wheight = document.documentElement.scrollTop || document.body.scrollTop // 已滚动高度
        // console.log(scrollHeight - nowScotop - wheight, this.isLoading);
        if (scrollHeight - nowScotop - wheight > 0 && scrollHeight - nowScotop - wheight < 100 && !this.isLoading) {
          this.isLoading = true
          this.page++
          this.getVipRecord()
        }
      }

    },

  },
  destroyed () {
    document.removeEventListener('scroll', this.scroll(), false)
    window.onscroll = null
    window.console.log('销毁了')
  }
}
</script>
<style lang='less' scoped>
.vipRecord {
  .recordList {
    padding: 0.3rem;
    .recordItem {
      width: 6.9rem;
      height: 2.06rem;
      box-sizing: border-box;
      padding: 0.3rem;
      margin-bottom: 0.2rem;
      background: #ffffff;
      box-shadow: 0 0.01rem 0.2rem 0 rgba(88, 88, 88, 0.1);
      border-radius: 0.1rem;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .line1 {
        display: flex;
        justify-content: space-between;

        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .itemName {
        }
      }
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        .origin {
          font-size: 0.22rem;
        }
      }
    }
  }
  // 暂无数据
  .nolog {
    .nodataImg {
      width: 2.64rem;
      height: 2.64rem;
      margin: 0 auto;
      margin-top: 2.98rem;
      img {
        display: block;
        width: 2.64rem;
        height: 2.64rem;
      }
    }
    .nodata {
      text-align: center;
      margin-top: 0.2rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
    }
  }
}
</style>
